/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { isNil } from 'lodash';

const NUMBER_DEFAULT_EPSILON = 0.00001;

export function isNumberZero(n: number, e: number = NUMBER_DEFAULT_EPSILON): boolean {
  return isNumberEquals(n, 0, e);
}

export function isNumberEquals(a: number, b: number, e: number = NUMBER_DEFAULT_EPSILON): boolean {
  return Math.abs(b - a) < e;
}

/**
 * Transforms zero number to undefined
 */
export function zeroNumberAsUndefined(n: Maybe<number>, e: number = NUMBER_DEFAULT_EPSILON): Maybe<number> {
  return isNil(n) ? void 0 : (isNumberZero(n, e) ? void 0 : n);
}
